import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";
import { siteUrl } from "../lib/schema";

const DEFAULT_DESC = "DJ Código — Dominican Roots. Global Sound. Independent Latin urban artist blending reggaetón, hip-hop and Caribbean club music. Stream the latest releases, watch videos and join the Código List.";

// Per-page head: title, description, canonical, Open Graph, Twitter cards, JSON-LD.
export default function Seo({ title, description, image, type = "website", path, jsonLd = [], noindex = false }) {
  const settings = useSettings();
  const location = useLocation();
  const base = siteUrl(settings);
  const canonical = `${base}${path ?? location.pathname}`;
  const fullTitle = title ? `${title} | DJ Código` : "DJ Código — Dominican Roots. Global Sound. | Latin Urban • Reggaetón • Hip-Hop";
  const desc = description || settings?.bioShort || DEFAULT_DESC;
  const img = image || settings?.seo?.defaultOgImage || settings?.artistImage;
  const schemas = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {settings?.seo?.keywords && <meta name="keywords" content={settings.seo.keywords} />}
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:site_name" content="DJ Código" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      {img && <meta property="og:image" content={img} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {img && <meta name="twitter:image" content={img} />}
      {schemas.filter(Boolean).map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
}
